<template>
  <div class="roles-main">
    <el-tabs type="border-card" class="rooms-tabs">
      <el-tab-pane :lazy="true">
        <template #label>
          <i class="el-icon-time" /> By Time
        </template>
        <roombyTime />
      </el-tab-pane>
      <el-tab-pane :lazy="true">
        <template #label>
          <i class="el-icon-user" /> By Agents
        </template>
        <roombyUser />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import roombyTime from '@/views/report/rooms/by-time'
import roombyUser from '@/views/report/rooms/by-user'
</script>

<style scoped>
.rooms-tabs.el-tabs--border-card {
  border-radius: 8px;
  border-color: var(--el-border-color-lighter, #ebeef5);
  box-shadow: none;
}
.rooms-tabs :deep(.el-tabs__header) {
  background: #f5f7fa;
}
.rooms-tabs :deep(.el-tabs__item.is-active) {
  background: #fff;
}
</style>
